import React from 'react'

import * as styles from './Wysiwyg.module.scss'

interface WysiwygProps {
	content: string
	className?: string
	fancyLists?: boolean
}

const Wysiwyg = (props: WysiwygProps) => {
	const contentStyles = [styles.wysiwyg]

	if (props.className) {
		contentStyles.push(props.className)
	}

	if (props.fancyLists) {
		contentStyles.push(styles.fancyLists)
	}

	return <div className={contentStyles.join(' ')} dangerouslySetInnerHTML={{ __html: props.content }}></div>
}

export default Wysiwyg
